module.exports = __webpack_public_path__ + "img/publisherslaptop.13f721dc.webp";